module.exports = __webpack_public_path__ + "static/img/大博科技园位置.cdffb81.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/大博科技园位置.png
// module id = /kV8
// module chunks = 1